import { createContext, useContext } from 'react';

const AnalyticsContext = createContext(null);

export const useAnalytics = () => {
  const { trackEvent, trackButtonClick } = useContext(AnalyticsContext);

  if (!trackEvent) {
    throw new Error('useAnalytics must be used within an AnalyticsProvider');
  }

  return {
    trackButtonClick,
    trackEvent
  };
};

export default AnalyticsContext;
